import React, { useState, useEffect, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import config from "../common/Config";
import { toast } from 'sonner';
import { getCompanySettings } from '../../utils/companySettingsCache';
import {
	Box,
	Button,
	Select,
	MenuItem,
	FormControl,
	InputLabel,
	Paper,
	Dialog,
	DialogTitle,
	DialogContent,
	DialogActions,
	CircularProgress,
	Snackbar,
	Alert,
	Typography,
	IconButton,
	Stack,
	TablePagination,
	TextField,
	InputAdornment,
	TableContainer,
	Table,
	TableHead,
	TableBody,
	TableRow,
	TableCell,
	Checkbox,
	Link as MuiLink,
	Grid2,
	Menu,
	ListItemIcon,
	ListItemText,
} from '@mui/material';
import { Iconify } from '../Minimal/src/components/iconify/iconify';
import "../common/commonStyles.css";
const columns = [
	{ id: "checkbox", label: "" },
	{ id: "invoice_date", label: "Inv Date" },
	{ id: "reference_no", label: "Inv No" },
	{ id: "customer", label: "Customer Name(A/C No)" },
	{ id: "postal_code", label: "Post Code" },
	{ id: "grand_total", label: "Invoice Amt", numeric: true },
	{ id: "total", label: "Total Due", numeric: true },
	{ id: "paid", label: "Sales Rep Cash", numeric: true },
	{ id: "route_number", label: "Route" },
	{ id: "created_by_name", label: "Added By" },
	{ id: "action", label: "Action" },
];

const CreateNewManifest = () => {
	const [driverOptions, setDriverOptions] = useState([]);
	const [driverValue, setDriverValue] = useState('');
	const [mIdValue, setMIdValue] = useState('');
	const [manifestList, setManifestList] = useState([]);
	const [checkedValues, setCheckedValues] = useState([]);
	const [routeOptions, setRouteOptions] = useState([]);
	const [salesRoute, setSalesRoute] = useState([]);
	const [selectedRouteValues, setSelectedRouteValues] = useState([]);
	const [selectedDriverValue, setSelectedDriverValue] = useState(null);
	const [flashMessage, setFlashMessage] = useState(null);
	const [snackbarOpen, setSnackbarOpen] = useState(false);
	const [showRouteModal, setShowRouteModal] = useState(false);
	const [showRouteIframe, setShowRouteIframe] = useState(true);
	const [iframeKey, setIframeKey] = useState(0);
	const [isIframeLoading, setIsIframeLoading] = useState(false);
	const [manifestIdForMap, setManifestIdForMap] = useState([]);
	const [showPrintConfirmDialog, setShowPrintConfirmDialog] = useState(false);
	const [createdManifestCode, setCreatedManifestCode] = useState(null);
	const accessToken = localStorage.getItem('accessToken');
	const token = localStorage.getItem("token");
	const user_id = localStorage.getItem('userId');
	const isRhp =
		String(config.PREFIX || "").toLowerCase() === "rhp" ||
		String(accessToken || "").toLowerCase() === "rhp" ||
		String(accessToken || "").toLowerCase() === "hp";
	const [companySettings, setCompanySettings] = useState(null);
	const [page, setPage] = useState(0);
	const [rowsPerPage, setRowsPerPage] = useState(50);
	const [searchInputValue, setSearchInputValue] = useState('');
	const [addedByFilter, setAddedByFilter] = useState("");
	const [postCodeFilter, setPostCodeFilter] = useState("");
	const [menuAnchor, setMenuAnchor] = useState(null);
	const [selectedOrderForMenu, setSelectedOrderForMenu] = useState(null);
	const [showRejectModal, setShowRejectModal] = useState(false);
	const [selectedOrder, setSelectedOrder] = useState(null);
	const [rejectReason, setRejectReason] = useState("");
	const [showHoldModal, setShowHoldModal] = useState(false);
	const [holdReason, setHoldReason] = useState("");

	const handleCloseMessage = () => {
		setFlashMessage(null);
		setSnackbarOpen(false);
	};

	const showFlashMessage = (message, type) => {
		setFlashMessage({ message, type });
		setSnackbarOpen(true);
	};

	const handleChangeRoute = (event) => {
		const values = event.target.value;
		setSalesRoute(typeof values === 'string' ? values.split(',') : values);
		setSelectedRouteValues(typeof values === 'string' ? values.split(',').map(v => routeOptions.find(opt => opt.value === v)).filter(Boolean) : values.map(v => routeOptions.find(opt => opt.value === v)).filter(Boolean));
		setAddedByFilter("");
		setPostCodeFilter("");
		setPage(0);
	};

	// Close dropdown when clicking outside

	const handelDriverChange = (event) => {
		const value = event.target.value;
		const selectedOption = driverOptions.find(opt => opt.value === value);
		setSelectedDriverValue(selectedOption || null);
		setDriverValue(value || '');
	};
	const navigate = useNavigate();

	const handleMenuOpen = (event, order) => {
		event.stopPropagation();
		setMenuAnchor(event.currentTarget);
		setSelectedOrderForMenu(order);
	};

	const handleMenuClose = (event) => {
		if (event) {
			event.stopPropagation();
		}
		setMenuAnchor(null);
		setSelectedOrderForMenu(null);
	};

	const handleRejectAction = () => {
		if (selectedOrderForMenu) {
			setSelectedOrder(selectedOrderForMenu);
			setShowRejectModal(true);
		}
		handleMenuClose();
	};

	const handlePrintAction = () => {
		if (selectedOrderForMenu) {
			window.open(`${config.BASE_URL}/trip_summary/print/${selectedOrderForMenu.id}`, '_blank');
		}
		handleMenuClose();
	};

	const handleHoldAction = () => {
		if (selectedOrderForMenu) {
			setSelectedOrder(selectedOrderForMenu);
			setHoldReason("");
			setShowHoldModal(true);
		}
		handleMenuClose();
	};

	const handleHoldSubmit = async (event) => {
		event.preventDefault();

		if (!selectedOrder || !holdReason.trim()) {
			toast.error("Please enter a reason for hold.");
			return;
		}

		const orderId = selectedOrder.id;
		const reason = holdReason;

		const formData = new FormData();
		formData.append("status", "Hold");
		formData.append("reason_note", reason);
		formData.append("id", orderId);
		formData.append("new-sales", 'No');

		if (accessToken === null) {
			window.location.href = `${config.BASE_URL}/login`;
			return;
		}

		try {
			const response = await fetch(`${config.API_URL}/ws-update-status`, {
				method: "POST",
				headers: {
					authorization: `Bearer ${token}`,
				},
				body: formData,
			});

			if (!response.ok) {
				const errorText = await response.text();
				throw new Error(
					`HTTP error! Status: ${response.status}. Error: ${errorText}`
				);
			}

			const data = await response.json();

			toast.success("Order held successfully.");
			setShowHoldModal(false);
			setHoldReason("");
			setSelectedOrder(null);
			window.location.reload();
		} catch (error) {
			toast.error("Error holding order. Please try again.");
		}
	};

	const updateReject = async (event) => {
		event.preventDefault();

		if (!selectedOrder || !rejectReason.trim()) {
			toast.error("Please enter a reason for rejection.");
			return;
		}

		const orderId = selectedOrder.id;
		const reason = rejectReason;

		const formData = new FormData();
		formData.append("status", "Reject");
		formData.append("reason_note", reason);
		formData.append("id", orderId);
		formData.append("new-sales", 'No');

		if (accessToken === null) {
			window.location.href = `${config.BASE_URL}/login`;
			return;
		}

		try {
			const response = await fetch(`${config.API_URL}/ws-update-status`, {
				method: "POST",
				headers: {
					authorization: `Bearer ${accessToken}`,
				},
				body: formData,
			});

			if (!response.ok) {
				const errorText = await response.text();
				throw new Error(
					`HTTP error! Status: ${response.status}. Error: ${errorText}`
				);
			}

			const data = await response.json();

			toast.success("Order rejected successfully.");
			setShowRejectModal(false);
			setRejectReason("");
			setSelectedOrder(null);
			window.location.reload();
		} catch (error) {
			toast.error("Error rejecting order. Please try again.");
		}
	};
	const createManifestEvent = async () => {
		if (checkedValues.length > 0) {
			const formData = new FormData();
			if (salesRoute.length > 0) {
				salesRoute.forEach(value => {
					formData.append('route_no[]', value);
				});
			}
			formData.append('mId', mIdValue);
			formData.append('user_id', user_id);
			checkedValues.forEach((value, index) => {
				formData.append('val[]', value);
			});

			if (driverValue != '') {
				formData.append('driver_id', driverValue);

				const apiAddOrdersUrl = `${config.API_URL}/ws-create-manifest-v2`;
				try {
					const response = await fetch(apiAddOrdersUrl, {
						method: 'POST',
						headers: {
							authorization: `Bearer ${token}`,
						},
						body: formData,
					});

					if (!response.ok) {
						showFlashMessage('something went wrong, try again', 'error');
					}
					const data = await response.json();
					if (data.success) {
						toast.success('Manifest created successfully!');
						setCheckedValues([]);
						setSalesRoute([]);
						setSelectedRouteValues([]);
						setDriverValue('');
						setSelectedDriverValue(null);

						setCreatedManifestCode(data.manifest_code);
						setShowPrintConfirmDialog(true);
					}
				} catch (error) {
					toast.error('Error Accept Order. Please try again.');
				}
			} else {
				showFlashMessage('please select driver', 'error');
			}
		} else {
			toast.error('Please select order to create manifest.');
		}
	};

	const goToManifestList = () => {
		setShowPrintConfirmDialog(false);
		navigate('/manifest_list');
	};

	const closePrintConfirmDialog = () => {
		setShowPrintConfirmDialog(false);
	};

	const fetchDriversOptions = async () => {
		const apiSalesRapUrl = `${config.API_URL}/getDriver`;
		try {
			const response = await fetch(apiSalesRapUrl, {
				method: 'POST',
				headers: {
					authorization: `Bearer ${accessToken}`,
				}
			});

			const data = await response.json();
			const formattedOptions = data.data.driver.map(item => ({
				label: `${item.first_name} ${item.last_name}`,
				value: item.id,
			}));
			setDriverOptions(formattedOptions);
		} catch (error) {
		}
	};

	const fetchSalesRoute = async () => {
		const apiSalesRouteUrl = `${config.API_URL}/getRoute`;
		try {
			const response = await fetch(apiSalesRouteUrl, {
				method: 'POST',
				headers: {
					authorization: `Bearer ${accessToken}`,
				}
			});

			const data = await response.json();
			const formattedOptions = data.data.map(item => ({
				label: item.route_number,
				value: item.id,
			}));
			setRouteOptions(formattedOptions);
		} catch (error) {
		}
	};

	const fetchRoutePlanningList = async () => {
		setCheckedValues([]);
		setManifestList([]);

		const routeData = new FormData();
		routeData.append('draw', 1);
		routeData.append('start', 0);
		routeData.append('length', 50);
		routeData.append('user_id', user_id);

		if (salesRoute.length > 0) {
			salesRoute.forEach(value => {
				routeData.append('route[]', value);
			});
		}

		const apiRoutePlanningUrl = `${config.API_URL}/ws-route-planning-list`;
		try {
			const response = await fetch(apiRoutePlanningUrl, {
				method: 'POST',
				headers: {
					authorization: `Bearer ${token}`,
				},
				body: routeData,
			});
			const data = await response.json();

			if (data.success) {
				setManifestList(data.data || []);
				setMIdValue(data.mid);
			} else {
				setManifestList([]);
			}
		} catch (error) {
			setManifestList([]);
		}
	};

	const searchManifestEvent = () => {
		fetchRoutePlanningList();
	};

	function formatDate(dateString) {
		if (!dateString) return '';
		const date = new Date(dateString);
		if (isNaN(date)) return dateString;
		const day = String(date.getDate()).padStart(2, '0');
		const month = String(date.getMonth() + 1).padStart(2, '0');
		const year = String(date.getFullYear()).slice(-4);
		return `${day}-${month}-${year}`;
	}

	const handleChangePage = (event, newPage) => {
		setPage(newPage);
	};

	const handleChangeRowsPerPage = (event) => {
		setRowsPerPage(parseInt(event.target.value, 10));
		setPage(0);
	};

	const handleSearchChange = (e) => {
		setSearchInputValue(e.target.value);
		setPage(0);
	};

	const visibleColumns = useMemo(
		() => (isRhp ? columns.filter((column) => column.id !== "paid") : columns),
		[isRhp]
	);

	const addedByOptions = useMemo(() => {
		const names = [...new Set(
			(manifestList || [])
				.map((row) => String(row.created_by_name || "").trim())
				.filter(Boolean)
		)];
		return names.sort((a, b) => a.localeCompare(b, undefined, { numeric: true }));
	}, [manifestList]);

	const postCodeOptions = useMemo(() => {
		const codes = [...new Set(
			(manifestList || [])
				.map((row) => String(row.postal_code || "").trim())
				.filter(Boolean)
		)];
		return codes.sort((a, b) => a.localeCompare(b, undefined, { numeric: true }));
	}, [manifestList]);

	const filteredData = useMemo(() => {
		const searchLower = searchInputValue.toLowerCase();
		return manifestList.filter((row) => {
			if (addedByFilter && String(row.created_by_name || "").trim() !== addedByFilter) {
				return false;
			}
			if (postCodeFilter && String(row.postal_code || "").trim() !== postCodeFilter) {
				return false;
			}
			if (!searchInputValue) return true;
			return (
				(row.reference_no && row.reference_no.toLowerCase().includes(searchLower)) ||
				(row.customer && row.customer.toLowerCase().includes(searchLower)) ||
				(row.accound_no && row.accound_no.toLowerCase().includes(searchLower)) ||
				(row.postal_code && row.postal_code.toLowerCase().includes(searchLower)) ||
				(row.route_number && String(row.route_number).toLowerCase().includes(searchLower)) ||
				(row.created_by_name && String(row.created_by_name).toLowerCase().includes(searchLower))
			);
		});
	}, [manifestList, searchInputValue, addedByFilter, postCodeFilter]);

	const paginatedData = useMemo(() => {
		const start = page * rowsPerPage;
		const end = start + rowsPerPage;
		return filteredData.slice(start, end);
	}, [filteredData, page, rowsPerPage]);

	const handleSelectAll = (event) => {
		if (event.target.checked) {
			const selectableIds = paginatedData
				.filter(row => row.grand_total > 0)
				.map(row => String(row.id));
			setCheckedValues(prev => {
				const newIds = selectableIds.filter(id => !prev.includes(id));
				return [...prev, ...newIds];
			});
		} else {
			const paginatedIds = paginatedData.map(row => String(row.id));
			setCheckedValues(prev => prev.filter(id => !paginatedIds.includes(id)));
		}
	};

	const handleSelectRow = (rowId) => {
		setCheckedValues(prev => {
			if (prev.includes(String(rowId))) {
				return prev.filter(id => id !== String(rowId));
			} else {
				return [...prev, String(rowId)];
			}
		});
	};

	const isAllSelected = paginatedData.length > 0 && paginatedData
		.filter(row => row.grand_total > 0)
		.every(row => checkedValues.includes(String(row.id)));

	const isIndeterminate = paginatedData
		.filter(row => row.grand_total > 0)
		.some(row => checkedValues.includes(String(row.id))) && !isAllSelected;

	useEffect(() => {
		if (accessToken === null) {
			window.location.href = `${config.BASE_URL}/login`;
			return;
		}

		fetchRoutePlanningList();
		fetchDriversOptions();
		fetchSalesRoute();
	}, []);

	useEffect(() => {
		if (showRouteModal) {
			setShowRouteIframe(false);
			setIsIframeLoading(true);
			setIframeKey(prev => prev + 1);

			const timer = setTimeout(() => {
				setShowRouteIframe(true);
			}, 100);

			window.closeRouteModal = () => {
				setShowRouteIframe(false);
				setIsIframeLoading(false);
				setTimeout(() => {
					setShowRouteModal(false);
				}, 100);
			};

			const handleEsc = (e) => {
				if (e.key === 'Escape') {
					setShowRouteIframe(false);
					setIsIframeLoading(false);
					setShowRouteModal(false);
				}
			};
			document.addEventListener('keydown', handleEsc);
			return () => {
				clearTimeout(timer);
				delete window.closeRouteModal;
				document.removeEventListener('keydown', handleEsc);
			};
		} else {
			setShowRouteIframe(false);
			setIsIframeLoading(false);
			return () => {
				delete window.closeRouteModal;
			};
		}
	}, [showRouteModal]);

	useEffect(() => {
		fetchRoutePlanningList();
	}, [salesRoute]);

	const fetchCompanySettings = async () => {
		try {
			const data = await getCompanySettings();
			setCompanySettings(data);
		} catch (error) {
		}
	};

	useEffect(() => {
		fetchCompanySettings();
	}, []);

	return (
		<>
			<Box className="page-container">
				<Paper className="paper-style">
					<Box sx={{ p: 1 }}>
						{companySettings && companySettings.isShowRutePlan === 'N' && (
							<Grid2
								container
								spacing={2}
								alignItems="center"
								justifyContent="space-between"
								sx={{ mb: 1 }}
							>
								<Grid2 size={{ xs: 12, sm: 6, md: 3 }}>
									<Typography className="page-title">
										Create Manifest
									</Typography>
								</Grid2>
								<Grid2 size={{ xs: 12, sm: 6, md: 9 }}>
									<Box
										sx={{
											display: "flex",
											justifyContent: { xs: "flex-start", sm: "flex-end" },
											alignItems: "center",
											gap: 2,
											flexWrap: "wrap",
										}}
									>
										<FormControl className="input-border" size="small" sx={{ width: { xs: '100%', md: '350px' } }}>
											<InputLabel id="driver-select-label">Select a driver</InputLabel>
											<Select
												labelId="driver-select-label"
												value={driverValue}
												label="Select a driver"
												onChange={handelDriverChange}
												sx={{
													"& .MuiSelect-select": {
														py: 1,
														fontSize: "14px",
													},
												}}
											>
												{driverOptions.map((option) => (
													<MenuItem key={option.value} value={option.value}>
														{option.label}
													</MenuItem>
												))}
											</Select>
										</FormControl>
										<Button
											variant="contained"
											className="button-variant-contained"
											onClick={createManifestEvent}
											sx={{
												width: { xs: '100%', md: 'auto' }, borderRadius: '8px', textTransform: 'none', fontWeight: 500, px: 2, py: 0.6,
											}}
										>
											Create Manifest
										</Button>
									</Box>
								</Grid2>
							</Grid2>
						)}
						<Box sx={{ display: "flex", gap: 1.5, alignItems: "center", flexWrap: { xs: "wrap", md: "nowrap" } }}>
							<TextField
								className="input-border"
								size="small"
								placeholder="Search orders..."
								value={searchInputValue}
								onChange={handleSearchChange}
								sx={{
									width: 280,
									flex: "0 0 280px",
									"& .MuiOutlinedInput-root": {
										backgroundColor: "#f5f7fa",
										"&:hover": { backgroundColor: "#fff" },
										"&.Mui-focused": { backgroundColor: "#fff" },
									},
								}}
								slotProps={{
									input: {
										startAdornment: (
											<InputAdornment position="start">
												<Iconify
													icon="eva:search-outline"
													width={20}
													height={20}
													sx={{ color: "#637381" }}
												/>
											</InputAdornment>
										),
									},
								}}
							/>
							<FormControl className="input-border" size="small" sx={{ minWidth: 160, flex: "0 0 auto" }}>
								<InputLabel id="added-by-filter-label">Added By</InputLabel>
								<Select
									labelId="added-by-filter-label"
									value={addedByFilter}
									label="Added By"
									onChange={(e) => {
										setAddedByFilter(e.target.value);
										setPage(0);
									}}
								>
									<MenuItem value="">All</MenuItem>
									{addedByOptions.map((name) => (
										<MenuItem key={name} value={name}>
											{name}
										</MenuItem>
									))}
								</Select>
							</FormControl>
							<FormControl className="input-border" size="small" sx={{ minWidth: 140, flex: "0 0 auto" }}>
								<InputLabel id="post-code-filter-label">Post Code</InputLabel>
								<Select
									labelId="post-code-filter-label"
									value={postCodeFilter}
									label="Post Code"
									onChange={(e) => {
										setPostCodeFilter(e.target.value);
										setPage(0);
									}}
								>
									<MenuItem value="">All</MenuItem>
									{postCodeOptions.map((code) => (
										<MenuItem key={code} value={code}>
											{code}
										</MenuItem>
									))}
								</Select>
							</FormControl>
							<FormControl className="input-border" size="small" sx={{ minWidth: 160, flex: "0 0 auto" }}>
								<InputLabel id="route-filter-label">Route</InputLabel>
								<Select
									labelId="route-filter-label"
									multiple
									value={salesRoute}
									label="Route"
									onChange={handleChangeRoute}
									renderValue={(selected) => {
										if (!selected || selected.length === 0) return "All";
										return selected
											.map((v) => routeOptions.find((opt) => String(opt.value) === String(v))?.label || v)
											.join(", ");
									}}
								>
									{routeOptions.map((option) => (
										<MenuItem key={option.value} value={option.value}>
											{option.label}
										</MenuItem>
									))}
								</Select>
							</FormControl>
							{!(companySettings && companySettings.isShowRutePlan === 'N') && (
								<Button
									variant="contained"
									className="button-variant-contained"
									onClick={() => {
										if (checkedValues.length > 0) {
											setShowRouteModal(true);
										} else {
											toast.error('At least one order should be selected to plan route.');
										}
									}}
									sx={{ flex: "0 0 auto", whiteSpace: "nowrap" }}
								>
									Plan Route
								</Button>
							)}
						</Box>
					</Box>
					<TableContainer>
						<Table
							size="small"
							className="table-cell-border"
							sx={{
								tableLayout: "auto",
							}}
						>
							<TableHead>
								<TableRow className="table-cell-header">
									<TableCell sx={{ px: 1 }}>
										<Checkbox
											indeterminate={isIndeterminate}
											checked={isAllSelected}
											onChange={handleSelectAll}
											size="small"
											color="#F8991D"
											className="checkBox"

										/>
									</TableCell>
									{visibleColumns.slice(1).map((column) => (
										<TableCell
											key={column.id}
											align={column.numeric ? "right" : "left"}

										>
											{column.label}
										</TableCell>
									))}
								</TableRow>
							</TableHead>
							<TableBody>
								{paginatedData.length > 0
									? paginatedData.map((row) => (
										<TableRow
											key={row.id}
											hover
											className="table-cell-style"
										>
											<TableCell padding="checkbox">
												{row.grand_total > 0 ? (
													<Checkbox
														checked={checkedValues.includes(String(row.id))}
														onChange={() => handleSelectRow(row.id)}
														size="small"
														className="checkBox"

													/>
												) : null}
											</TableCell>
											<TableCell >
												{formatDate(row.invoice_date)}
											</TableCell>
											<TableCell >
												<MuiLink
													href={`${config.BASE_URL}/edit/proforma/${row.id}`}
													target="_blank"
													rel="noopener noreferrer"
													sx={{
														color: "inherit",
														textDecoration: "underline !important",
														textDecorationColor: "currentColor",
														textUnderlineOffset: "2px",
														"&:hover": {
															textDecoration: "underline !important",
															textDecorationColor: "currentColor"
														}
													}}
												>
													{row.reference_no}
												</MuiLink>
											</TableCell>
											<TableCell sx={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", maxWidth: "300px" }}>
												{row.customer ? `${row.customer}(${row.accound_no})` : ''}
											</TableCell>
											<TableCell >
												{row.postal_code}
											</TableCell>
											<TableCell align="right" >
												{row.grand_total}
											</TableCell>
											<TableCell align="right" >
												{row.total}
											</TableCell>
											{!isRhp && (
												<TableCell align="right" >
													{row.paid}
												</TableCell>
											)}
											<TableCell >
												{row.route_number}
											</TableCell>
											<TableCell >
												{row.created_by_name}
											</TableCell>
											<TableCell align="center" >
												<IconButton
													size="small"
													onClick={(e) => handleMenuOpen(e, row)}
													sx={{
														color: "#637381",
														"&:hover": {
															backgroundColor: "rgba(0, 0, 0, 0.04)"
														}
													}}
												>
													<Iconify icon="eva:more-vertical-fill" width={18} height={18} />
												</IconButton>
											</TableCell>
										</TableRow>
									))
									: (
										<TableRow>
											<TableCell colSpan={visibleColumns.length} sx={{ py: 4 }}>
												<Typography align="center">
													No data available for the selected routes
												</Typography>
											</TableCell>
										</TableRow>
									)}
							</TableBody>
						</Table>
					</TableContainer>
					{filteredData.length > 0 && (
						<Box display="flex" justifyContent="flex-end" alignItems="center">
							<TablePagination
								component="div"
								count={filteredData.length}
								page={page}
								onPageChange={handleChangePage}
								rowsPerPage={rowsPerPage}
								onRowsPerPageChange={handleChangeRowsPerPage}
								rowsPerPageOptions={[10, 25, 50, 100]}
								className="pagination-styles"
							/>
						</Box>
					)}
				</Paper>
			</Box>

			<Snackbar
				open={snackbarOpen}
				autoHideDuration={3000}
				onClose={handleCloseMessage}
				anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
			>
				<Alert
					onClose={handleCloseMessage}
					severity={flashMessage?.type === 'error' ? 'error' : 'success'}
					sx={{ width: '100%' }}
				>
					{flashMessage?.message}
				</Alert>
			</Snackbar>

			<Dialog
				open={showRouteModal}
				onClose={() => {
					setShowRouteIframe(false);
					setIsIframeLoading(false);
					setShowRouteModal(false);
				}}
				maxWidth={false}
				fullWidth
				PaperProps={{
					sx: {
						maxWidth: '90%',
						height: '90vh',
						m: 0,
					},
				}}
			>
				<DialogContent sx={{ p: 0, height: '100%', position: 'relative' }}>
					<IconButton
						onClick={() => {
							setShowRouteIframe(false);
							setIsIframeLoading(false);
							setShowRouteModal(false);
						}}
						sx={{
							position: 'absolute',
							right: 8,
							top: 8,
							zIndex: 1000,
							backgroundColor: '#f44336',
							color: 'white',
							'&:hover': {
								backgroundColor: '#d32f2f',
							},
						}}
					>
						<Iconify icon="mdi:close" width={24} height={24} />
					</IconButton>

					{isIframeLoading && (
						<Box
							sx={{
								position: 'absolute',
								top: '50%',
								left: '50%',
								transform: 'translate(-50%, -50%)',
								zIndex: 999,
								backgroundColor: 'background.paper',
								p: 3,
								borderRadius: 2,
								boxShadow: 3,
							}}
						>
							<Stack direction="column" spacing={2} alignItems="center">
								<CircularProgress />
								<Typography>Loading route planner...</Typography>
							</Stack>
						</Box>
					)}

					{showRouteIframe && (
						<iframe
							key={`route-iframe-${iframeKey}`}
							src={`/maproute.html?postcodes=${checkedValues && checkedValues.length > 0 ? checkedValues.join(',') : ''}`}
							width="100%"
							height="100%"
							style={{ border: 'none' }}
							title="Route Planner"
							onLoad={() => {
								setIsIframeLoading(false);
							}}
							onError={(e) => {
								setIsIframeLoading(false);
							}}
						/>
					)}
				</DialogContent>
			</Dialog>

			<Dialog
				open={showPrintConfirmDialog}
				onClose={closePrintConfirmDialog}
				PaperProps={{
					sx: {
						borderRadius: 2,
					},
				}}
			>
				<DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
					<Typography variant="h6" sx={{ fontWeight: 600 }}>
						Manifest Created Successfully!
					</Typography>
					<IconButton
						onClick={closePrintConfirmDialog}
						sx={{ color: '#637381' }}
					>
						<Iconify icon="mdi:close" width={24} height={24} />
					</IconButton>
				</DialogTitle>
				<DialogContent>
					<Typography sx={{ fontSize: '14px', color: '#637381' }}>
						Do you want to print the created manifest?
					</Typography>
				</DialogContent>
				<DialogActions sx={{ px: 3, pb: 2 }}>
					<Button
						onClick={goToManifestList}
						className="button-variant-outlined"
						variant="outlined"
					>
						No, Continue
					</Button>
					<Button
						variant="contained"
						className="button-variant-contained"
						onClick={() => {
							setShowPrintConfirmDialog(false);
							if (createdManifestCode) {
								navigate(`/manifest_list/mark_delivery/${createdManifestCode}?print=true`);
							}
						}}

					>
						Yes, Print
					</Button>
				</DialogActions>
			</Dialog>

			<Dialog
				open={showRejectModal}
				onClose={() => {
					setShowRejectModal(false);
					setRejectReason("");
				}}
				maxWidth="sm"
				fullWidth
				PaperProps={{
					sx: {
						borderRadius: 2,
					},
				}}
			>
				<DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
					<Typography className="page-title">
						Reject Order
					</Typography>
					<IconButton
						onClick={() => {
							setShowRejectModal(false);
							setRejectReason("");
						}}
						sx={{ color: '#637381' }}
					>
						<Iconify icon="mdi:close" width={24} height={24} />
					</IconButton>
				</DialogTitle>
				<DialogContent dividers>
					{selectedOrder && (
						<>
							<Typography sx={{ fontWeight: 500, color: "#212b36", fontSize: "1rem" }}>
								Order Details
							</Typography>
							<Table size="small" sx={{ mb: 2 }} className="table-cell-border">
								<TableBody>
									<TableRow>
										<TableCell >Order Id</TableCell>
										<TableCell>{selectedOrder.reference_no}</TableCell>
									</TableRow>
									<TableRow>
										<TableCell >Customer (A/C)</TableCell>
										<TableCell>{selectedOrder.customer ? `${selectedOrder.customer}(${selectedOrder.accound_no})` : ''}</TableCell>
									</TableRow>
									<TableRow>
										<TableCell >Order Amount</TableCell>
										<TableCell>{selectedOrder.grand_total}</TableCell>
									</TableRow>
									<TableRow>
										<TableCell >Total Due</TableCell>
										<TableCell>{selectedOrder.total || "N/A"}</TableCell>
									</TableRow>
								</TableBody>
							</Table>
							<TextField
								className="form-input-border"
								label="Reason Note"
								value={rejectReason}
								onChange={(e) => setRejectReason(e.target.value)}
								multiline
								minRows={3}
								fullWidth
								required
								sx={{
									'& .MuiOutlinedInput-root': {
										borderRadius: '8px',
									},
								}}
							/>
						</>
					)}
				</DialogContent>
				<DialogActions sx={{ px: 3, pb: 2 }}>
					<Button
						onClick={() => {
							setShowRejectModal(false);
							setRejectReason("");
						}}
						variant="outlined"
						className="button-variant-outlined"
					>
						Cancel
					</Button>
					<Button
						variant="contained"
						onClick={updateReject}
						className="button-variant-contained"
					>
						Update
					</Button>
				</DialogActions>
			</Dialog>

			<Dialog
				open={showHoldModal}
				onClose={() => {
					setShowHoldModal(false);
					setHoldReason("");
				}}
				maxWidth="sm"
				fullWidth
				PaperProps={{
					sx: {
						borderRadius: 2,
					},
				}}
			>
				<DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
					<Typography className="page-title">
						Hold Order
					</Typography>
					<IconButton
						onClick={() => {
							setShowHoldModal(false);
							setHoldReason("");
						}}
						sx={{ color: '#637381' }}
					>
						<Iconify icon="mdi:close" width={24} height={24} />
					</IconButton>
				</DialogTitle>
				<DialogContent dividers>
					{selectedOrder && (
						<>
							<Typography sx={{ fontWeight: 500, color: "#212b36", fontSize: "1rem" }}>
								Order Details
							</Typography>
							<Table size="small" sx={{ mb: 2 }} className="table-cell-border">
								<TableBody>
									<TableRow>
										<TableCell sx={{ fontWeight: 500, width: '40%' }}>Order Id</TableCell>
										<TableCell>{selectedOrder.reference_no}</TableCell>
									</TableRow>
									<TableRow>
										<TableCell sx={{ fontWeight: 500 }}>Customer (A/C)</TableCell>
										<TableCell>{selectedOrder.customer ? `${selectedOrder.customer}(${selectedOrder.accound_no})` : ''}</TableCell>
									</TableRow>
									<TableRow>
										<TableCell sx={{ fontWeight: 500 }}>Order Amount</TableCell>
										<TableCell>{selectedOrder.grand_total}</TableCell>
									</TableRow>
									<TableRow>
										<TableCell sx={{ fontWeight: 500 }}>Total Due</TableCell>
										<TableCell>{selectedOrder.total || "N/A"}</TableCell>
									</TableRow>
								</TableBody>
							</Table>
							<TextField
								label="Reason Note"
								value={holdReason}
								onChange={(e) => setHoldReason(e.target.value)}
								multiline
								minRows={3}
								fullWidth
								required
								className="form-input-border"
								sx={{
									'& .MuiOutlinedInput-root': {
										borderRadius: '8px',
									},
								}}
							/>
						</>
					)}
				</DialogContent>
				<DialogActions sx={{ px: 3, pb: 2 }}>
					<Button
						onClick={() => {
							setShowHoldModal(false);
							setHoldReason("");
						}}
						variant="outlined"
						className="button-variant-outlined"
					>
						Cancel
					</Button>
					<Button
						variant="contained"
						onClick={handleHoldSubmit}
						className="button-variant-contained"

					>
						Update
					</Button>
				</DialogActions>
			</Dialog>

			<Menu
				anchorEl={menuAnchor}
				open={Boolean(menuAnchor)}
				onClose={handleMenuClose}
				onClick={(e) => e.stopPropagation()}
				anchorOrigin={{
					vertical: 'bottom',
					horizontal: 'right',
				}}
				transformOrigin={{
					vertical: 'top',
					horizontal: 'right',
				}}
				PaperProps={{
					onClick: (e) => e.stopPropagation(),
					sx: {
						minWidth: 200,
						borderRadius: 2,
						boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)',
						mt: 1,
					},
				}}
			>
				<MenuItem onClick={handlePrintAction}>
					<ListItemIcon>
						<Iconify icon="eva:printer-fill" width={20} height={20} />
					</ListItemIcon>
					<ListItemText>Print</ListItemText>
				</MenuItem>
				<MenuItem onClick={handleHoldAction}>
					<ListItemIcon>
						<Iconify icon="eva:pause-circle-fill" width={20} height={20} />
					</ListItemIcon>
					<ListItemText>Hold</ListItemText>
				</MenuItem>
				<MenuItem onClick={handleRejectAction}>
					<ListItemIcon>
						<Iconify icon="eva:close-circle-fill" width={20} height={20} />
					</ListItemIcon>
					<ListItemText>Reject Order</ListItemText>
				</MenuItem>
			</Menu>

		</>
	);
};

export default CreateNewManifest;

